import {
    FETCH_ALL_FEATURE_NAMESPACES_FAILURE,
    FETCH_ALL_FEATURE_NAMESPACES_SUCCESS
} from "../../actions/action_types";
import {namespaceInitialState} from "src/model/featureGeneration/feature_generation_models";

export default function (state = namespaceInitialState, action: any) {
    switch (action.type) {
        case FETCH_ALL_FEATURE_NAMESPACES_SUCCESS:
            return {
                ...state,
                namespaceList: action.payload
            }

        case FETCH_ALL_FEATURE_NAMESPACES_FAILURE:
            return {
                ...state,
                namespaceList: []
            }

        default:
            return state;
    }
}
